import { PageWrapper } from '@innovyze/stylovyze';
import styled from 'styled-components';

export const Container = styled.div`
	display: grid;
	max-width: 644px;
`;

export const CustomPageWrapper = styled(PageWrapper)`
	&& h3 {
		font-style: normal;
		font-weight: normal;
		font-size: 24px;
		margin: 0;
		padding: 0;
	}
`;
